import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { generalCatalogPatch } from "../../store/generalCatalog/actions";
export var useGeneralCatalogPatch = function (trigger, body, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseGeneralCatalogPatch: (_a = state.GeneralCatalog.responseGeneralCatalogPatch) === null || _a === void 0 ? void 0 : _a.data,
            errorGeneralCatalogPatch: state.GeneralCatalog.errorGeneralCatalogPatch,
            loadingGeneralCatalogPatch: state.GeneralCatalog.loadingGeneralCatalogPatch,
        });
    }), responseGeneralCatalogPatch = _a.responseGeneralCatalogPatch, errorGeneralCatalogPatch = _a.errorGeneralCatalogPatch, loadingGeneralCatalogPatch = _a.loadingGeneralCatalogPatch;
    useEffect(function () {
        if (trigger) {
            dispatch(generalCatalogPatch({
                clientId: body.data.clientId,
                parentCatalogId: null,
                type: body.data.type,
                code: body.data.code,
                description: body.data.description,
            }, id));
        }
    }, [trigger, body.data.clientId]);
    return {
        responseGeneralCatalogPatch: responseGeneralCatalogPatch,
        errorGeneralCatalogPatch: errorGeneralCatalogPatch,
        loadingGeneralCatalogPatch: loadingGeneralCatalogPatch,
    };
};
